import { PopupBuilder } from '@mobile/views/Relation/Shared/Popup/builder/PopupBuilder'

import ConfirmSendingIncidentPopupDetails from './ConfirmSendingIncidentPopupDetails.vue'

export const ConfirmSendingIncidentPopup = new PopupBuilder(
  'Confirm sending incident',
)
  .appendBody(ConfirmSendingIncidentPopupDetails)
  .build()
